import React, { useState } from 'react';

import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const SearchFilterBar = ({ onSearch, onFilter, totalItems }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    type: 'all',
    pricingModel: 'all',
    status: 'all',
    showInactive: false
  });
  const [isFilterExpanded, setIsFilterExpanded] = useState(false);

  const typeOptions = [
    { value: 'all', label: 'Tous les types' },
    { value: 'category', label: 'Catégories' },
    { value: 'equipment', label: 'Équipements' },
    { value: 'problem', label: 'Problèmes' },
    { value: 'service', label: 'Services' }
  ];

  const pricingOptions = [
    { value: 'all', label: 'Tous les tarifs' },
    { value: 'fixed', label: 'Prix fixe' },
    { value: 'quote', label: 'Sur devis' }
  ];

  const statusOptions = [
    { value: 'all', label: 'Tous les statuts' },
    { value: 'active', label: 'Actifs' },
    { value: 'inactive', label: 'Inactifs' }
  ];

  const handleSearchChange = (e) => {
    const value = e?.target?.value;
    setSearchQuery(value);
    onSearch(value);
  };

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    onFilter(newFilters);
  };

  const clearFilters = () => {
    const defaultFilters = {
      type: 'all',
      pricingModel: 'all',
      status: 'all',
      showInactive: false
    };
    setFilters(defaultFilters);
    setSearchQuery('');
    onFilter(defaultFilters);
    onSearch('');
  };

  const hasActiveFilters = 
    filters?.type !== 'all' || 
    filters?.pricingModel !== 'all' || 
    filters?.status !== 'all' || 
    filters?.showInactive ||
    searchQuery?.length > 0;

  return (
    <div className="bg-card rounded-lg border border-border p-4 space-y-4">
      <div className="flex items-center gap-3">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Rechercher dans le catalogue..."
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full"
          />
        </div>
        <Button
          variant="outline"
          iconName={isFilterExpanded ? 'ChevronUp' : 'Filter'}
          onClick={() => setIsFilterExpanded(!isFilterExpanded)}
        >
          Filtres
          {hasActiveFilters && (
            <span className="ml-2 px-2 py-0.5 bg-primary text-primary-foreground text-xs rounded-full">
              {[filters?.type !== 'all', filters?.pricingModel !== 'all', filters?.status !== 'all', filters?.showInactive]?.filter(Boolean)?.length}
            </span>
          )}
        </Button>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            iconName="X"
            onClick={clearFilters}
            size="sm"
          >
            Réinitialiser
          </Button>
        )}
      </div>
      {isFilterExpanded && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4 border-t border-border animate-slide-up">
          <Select
            label="Type"
            options={typeOptions}
            value={filters?.type}
            onChange={(value) => handleFilterChange('type', value)}
          />

          <Select
            label="Tarification"
            options={pricingOptions}
            value={filters?.pricingModel}
            onChange={(value) => handleFilterChange('pricingModel', value)}
          />

          <Select
            label="Statut"
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => handleFilterChange('status', value)}
          />

          <div className="md:col-span-3">
            <Checkbox
              label="Afficher les éléments inactifs"
              checked={filters?.showInactive}
              onChange={(e) => handleFilterChange('showInactive', e?.target?.checked)}
            />
          </div>
        </div>
      )}
      <div className="flex items-center justify-between text-xs text-muted-foreground pt-2 border-t border-border">
        <span>{totalItems} élément(s) dans le catalogue</span>
        {searchQuery && (
          <span>Résultats de recherche pour "{searchQuery}"</span>
        )}
      </div>
    </div>
  );
};

export default SearchFilterBar;